/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NetworkStatusTimespan } from './networkStatusTimespan';
import { DataPlanTimespan } from './dataPlanTimespan';
import { StringTimespan } from './stringTimespan';
import { LongTimespan } from './longTimespan';


export interface BatchDevice { 
    id: number;
    networkStatusTimespan?: NetworkStatusTimespan;
    dataPlanTimespan?: DataPlanTimespan;
    paymentAccountTimespan?: LongTimespan;
    usedBytesInTestPlan?: number;
    airtimeNetworkStatusChangeRequested?: BatchDevice.AirtimeNetworkStatusChangeRequestedEnum;
    comIdTimeline?: Array<StringTimespan>;
    insertTs: string;
    manufacturingStatus: BatchDevice.ManufacturingStatusEnum;
    weight?: number;
    comType?: BatchDevice.ComTypeEnum;
    internalDropOffId?: number;
    externalDropOffId?: number;
    configConfirmed?: string;
}
export namespace BatchDevice {
    export const AirtimeNetworkStatusChangeRequestedEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type AirtimeNetworkStatusChangeRequestedEnum = typeof AirtimeNetworkStatusChangeRequestedEnum[keyof typeof AirtimeNetworkStatusChangeRequestedEnum];
    export const ManufacturingStatusEnum = {
        New: 'New',
        Assigned: 'Assigned',
        ReadyForTest: 'ReadyForTest',
        Testing: 'Testing',
        ManufacturingCompleted: 'ManufacturingCompleted',
        Packed: 'Packed',
        Shipped: 'Shipped',
        Canceled: 'Canceled',
        ManufacturingFailed: 'ManufacturingFailed'
    } as const;
    export type ManufacturingStatusEnum = typeof ManufacturingStatusEnum[keyof typeof ManufacturingStatusEnum];
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
}


export type ManufacturingStatusEnum = typeof BatchDevice.ManufacturingStatusEnum[keyof typeof BatchDevice.ManufacturingStatusEnum];
